import { Config, ErrorHandling, TranslationConfig } from "@serenity-is/corelib";
import { gridDefaults } from "@serenity-is/sleekgrid";
import flatpickr from "flatpickr";
import "flatpickr/dist/l10n";
import { getLanguageList } from "./Helpers/LanguageList";
import { initGardenSelection } from "./Helpers/GardenSelection";
import { initLanguageSelection } from "./Helpers/LanguageSelection";
import DOMPurify from "dompurify";

Config.rootNamespaces.push('NewHV');
TranslationConfig.getLanguageList = getLanguageList;
gridDefaults.sanitizer = (globalThis.DOMPurify = DOMPurify).sanitize;

let culture = (document.documentElement?.lang || 'en').toLowerCase();
if (flatpickr.l10ns[culture]) {
    flatpickr.localize(flatpickr.l10ns[culture]);
} else {
    culture = culture.split('-')[0];
    flatpickr.l10ns[culture] && flatpickr.localize(flatpickr.l10ns[culture]);
}

window.onerror = ErrorHandling.runtimeErrorHandler;
window.addEventListener('unhandledrejection', ErrorHandling.unhandledRejectionHandler);

// Only present on pages that render Views/Shared/_Sidebar.cshtml (not on hideNav pages like Login).
var gardenSelectionMenu = document.getElementById('s-garden-selection-menu');
if (gardenSelectionMenu)
    initGardenSelection({ menu: gardenSelectionMenu });

var languageSelectionMenu = document.getElementById('s-language-selection-menu');
if (languageSelectionMenu)
    initLanguageSelection({ menu: languageSelectionMenu, currentLanguage: culture });
